import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=1eda65ec&scoped=true"
import script from "./OrganizationCard.vue?vue&type=script&lang=js"
export * from "./OrganizationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda65ec",
  null
  
)

export default component.exports